import { render, staticRenderFns } from "./AttendeesStep.vue?vue&type=template&id=57ff2b20&scoped=true&"
import script from "./AttendeesStep.vue?vue&type=script&lang=js&"
export * from "./AttendeesStep.vue?vue&type=script&lang=js&"
import style0 from "./AttendeesStep.vue?vue&type=style&index=0&id=57ff2b20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff2b20",
  null
  
)

export default component.exports